type CategoryList = {
  readonly [key: string]: {
    readonly label: readonly string[];
    readonly value: readonly string[];
  };
};

export const CATEGORY_LIST: CategoryList = {
  fashion: {
    label: ['여성패션', '남성패션', '남녀 공용 의류', '악세사리', '신발', '유아동패션', '기타패션'],
    value: [
      'womens_fashion',
      'mens_fashion',
      'mens_and_womens_clothing',
      'accessories',
      'shoes',
      'infant_fashion',
      'other_fashion',
    ],
  },
  beauty: {
    label: [
      '스킨케어',
      '클렌징/필링',
      '메이크업',
      '향수',
      '네일',
      '헤어',
      '바디',
      '구강/면도',
      '남성화장품',
      '반려뷰티',
      '유아동뷰티',
      '기타뷰티',
    ],
    value: [
      'skincare',
      'cleansing_filling',
      'make_up',
      'perfume',
      'nail',
      'hair',
      'body',
      'oral_shaving',
      'mens_cosmetics',
      'companion_beauty',
      'childhood_beauty',
      'other_beauty',
    ],
  },
  food: {
    label: [
      '과일',
      '축산/수산',
      '유제품',
      '음료',
      '간편조리',
      '건강식품',
      '간식',
      '유아동',
      '반려식품',
      '기타식품',
    ],
    value: [
      'fruit',
      'livestock_fisheries',
      'daily_products',
      'beverage',
      'easy_cooking',
      'health_food',
      'snack',
      'infant_food',
      'a_toddlers_child',
      'other_food',
    ],
  },
  kitchen: {
    label: ['주방가전', '주방도구', '주방가구', '주방잡화', '기타주방'],
    value: [
      'kitchen_appliances',
      'kitchen_utensils',
      'kitchen_furniture',
      'kitchen_miscellaneous_goods',
      'other_kitchens',
    ],
  },
  home_appliances: {
    label: [
      '계절생활',
      '청소용품',
      '건강/의료',
      '정리',
      '성인(19)',
      '욕실',
      '생활잡화',
      '반려용품',
      '헬스',
      '유아동용품',
      '완구/교구',
      '출산',
      '기타생활',
    ],
    value: [
      'seasonal_life',
      'cleaning_supplies',
      'health_medical_care',
      'arrangement',
      'adult',
      'bathroom',
      'miscellaneous_goods',
      'companion_goods',
      'health',
      'baby_and_child_supplies',
      'toys_parishes',
      'child_birth',
      'other_life',
    ],
  },
  home_interior: {
    label: [
      '크리스마스용품',
      '방한용품',
      '홈데코',
      '가구',
      '수납/정리',
      '침구',
      '커튼/블라인드',
      '카페트/쿠션/거실화',
      '수예/수선',
      '욕실용품',
      '조명/스탠드',
      '셀프인테리어',
      '원예/가드닝',
      '생활전기용품',
      '안전/호신용품',
      '기타 인테리어',
    ],
    value: [
      'christmas_goods',
      'cold_weather_supplies',
      'home_decoration',
      'furiture',
      'storage_organization',
      'bedding',
      'a_curtain_blind',
      'carpet_cushion_living_shoes',
      'a_handiwork_repair',
      'batroom_supplies',
      'lighting_stand',
      'self_interiors',
      'gardening',
      'household_electrical_appliances',
      'safety_protection_goods',
      'other_interiors',
    ],
  },
  electronics: {
    label: [
      '생활가전',
      '계절가전',
      '뷰티가전',
      '건강가전',
      '주방가전',
      '사무가전',
      '음향기기',
      '반려가전',
      '기타가전',
    ],
    value: [
      'household_appliances',
      'seasonal_home_appliances',
      'beauty_appliances',
      'health_appliances',
      'kitche_appliances',
      'office_appliances',
      'sound_equipment',
      'a_home_appliance',
      'other_electronics',
    ],
  },
  health: {
    label: [
      '건강기능식품',
      '성인용 건강식품',
      '임산부 건강식품',
      '시니어 건강식품',
      '어린이 건강식품',
      '유아동영양제',
      '영양제',
      '헬스보충식품',
      '다이어트/이너뷰티',
      '헬스/요가용품',
      '기타',
    ],
    value: [
      'health_functional_food',
      'health_food_for_adults',
      'women',
      'senior_health_foods',
      'healthy_food_for_children',
      'infant_motor_nutritional_supplements',
      'nutritional_supplements',
      'health_supplements',
      'diet_inner_beauty',
      'health_yoga_supplies',
      'others',
    ],
  },
  travel: {
    label: [
      '국내여행',
      '호텔/리조트',
      '티켓/패스',
      '펜션/캠핑',
      '패키지여행/항공',
      '렌터카',
      '해외여행',
      '패키지여행',
      '자유여행/항공',
      '티켓/패스/현지투어',
      '공연티켓',
    ],
    value: [
      'domestic_travel',
      'hotel_resort',
      'tickets_passes',
      'a_pension_camping',
      'a_package_tour_airline',
      'a_rental_car',
      'an_overseas_trip',
      'a_package_tour',
      'free_travel_aircraft',
      'a_ticket_pass_local_tour',
      'concert_tickets',
    ],
  },
} as const;

export const CONTENT_CATEGORY: Record<string, string> = {
  fashion: '패션',
  beauty: '뷰티',
  food: '식품',
  kitchen: '주방용품',
  home_appliances: '생활용품',
  home_interior: '홈인테리어',
  electronics: '가전디지털',
  health: '헬스/건강',
  travel: '여행/티켓',
} as const;
